import SupplierTableFilter from './supplier-table-filter';

export default SupplierTableFilter;